import { createStyles } from '../../../../../../../../../../../../../styles/helpers'
import { darkGrey, red } from '../../../../../../../../../../../../../styles/const/colors'
import { periodsValidationIcon } from '../styles'
import { zIndex10 } from '../../../../../../../../../../../../../styles/const/common'
import { calendarMargin } from '../../../../../../../../../../../../../pages/Proposals/ProductsCalendarPreview/styles'

export default createStyles({
  competingErrorIcon: {
    extend: periodsValidationIcon,
    color: red
  },
  dropdownBody: {
    zIndex: zIndex10, // show on top of the Drawer,
    maxWidth: '100%'
  },
  dropdownBodyWrapper: {
    padding: '22px 22px 40px',
    maxHeight: '80vh',
    overflowY: 'auto'
  },
  calendarPreview: {
    maxWidth: '800px',
    marginTop: calendarMargin,
    overflow: 'hidden' // hide events on edges which are few mm outside of the calendar
  },
  description: {
    color: darkGrey,
    marginTop: 4
  },
  noPeriods: {
    color: darkGrey,
    marginTop: 16
  }
})
